import React, { useCallback } from "react";
import { connect } from "react-redux";
import {
  isSubmittingCategory,
  getSubmitCategoryFailure,
  actions
} from "../modules/market";
import CategoryForm from "./CategoryForm";

const AddCategoryForm = connect(
  state => ({
    dealer: state.dealers.currentDealer,
    submittingCategory: isSubmittingCategory(state),
    failSubmitCategory: getSubmitCategoryFailure(state)
  }),
  {
    createCategory: actions.createCategory
  }
)(
  ({
    failSubmitCategory,
    submittingCategory,
    createCategory,
    dealer,
    onSubmitSuccess
  }) => {
    const onSubmit = useCallback(
      async (data, { resetForm }) => {
        const result = await createCategory({ data, dealer_id: dealer.id });
        if (result.response) {
          resetForm();
          onSubmitSuccess(result.response.data);
        }
      },
      [createCategory, dealer, onSubmitSuccess]
    );
    return (
      <CategoryForm
        failSubmitCategory={failSubmitCategory}
        submittingCategory={submittingCategory}
        onSubmit={onSubmit}
      />
    );
  }
);

export default AddCategoryForm;
